// The matter's AI summary, written on request. The server's own sentence
// comes back on a refusal (AI switched off, no key, out of credit, busy).

import { getAuthHeaders } from "./auth";

export async function generateCaseSummary(
  caseId: string,
): Promise<{ summary: string; generatedAt: string }> {
  const res = await fetch(`/api/cases/${encodeURIComponent(caseId)}/generate-summary`, {
    method: "POST",
    headers: { ...getAuthHeaders() },
    credentials: "same-origin",
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new Error(body?.error ?? `Could not write the summary (HTTP ${res.status}).`);
  }
  return (await res.json()) as { summary: string; generatedAt: string };
}
